import React from "react";
import { FiEdit3, FiChevronUp, FiChevronDown } from "react-icons/fi";
import { FaUser } from "react-icons/fa";
import { TbSearch } from "react-icons/tb";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { PiNoteFill } from "react-icons/pi";
import { useHistory } from "react-router-dom";
import { RateTypeShippingEnum } from "../../../../enums/RateTypeShippingEnum";
import formatCep from "../../../../utils/FormatCep";
import { momentBDays } from "../../../../utils/MomentBDay";
import styles from "./styles.module.scss";
import ShippingStagesEnum from "../../../../enums/ShippingStagesEnum";
import { StyledTooltip } from "../../components/Tooltip";
import { addBusinessDaysIgnoreHolidays } from "../../../../utils/calculateBusinessDay";

export function CartSimpleCardShipping({
  shipping,
  onExpand,
  isExpand,
  widthWindows,
  isCancelled,
  edit = true,
  expand = true,
}) {
  const history = useHistory();

  const addressInfoHandled = address => {
    let finalAddress = address?.street;

    if (!!address?.number) {
      finalAddress += `, ${address?.number}`;
    }

    if (!!address?.complement) {
      finalAddress += `, ${address?.complement}`;
    }

    if (!!address?.district) {
      finalAddress += `, ${address?.district}`;
    }

    return finalAddress;
  };

  const handleStatusColor = status => {
    const color = {
      [ShippingStagesEnum.ENTREGA_REALIZADA.id]: "#409E6A",
      [ShippingStagesEnum.OBJETO_EM_TRANSITO.id]: "#F5CB2B",
      [ShippingStagesEnum.OBJETO_SAIU_PARA_ENTREGA.id]: "#F5CB2B",
      [ShippingStagesEnum.OBJETO_NAO_FOI_ENTREGUE.id]: "#CA1818"
    };

    return color[status];
  };

  const clientName = shipping?.user?.userData[1]?.Value?.split(" ", 2).join(
    " "
  );

  return (
    <>
      <div
        className={`${styles.cardWrapper}
      ${shipping.blocked && styles.blockedCard} ${isCancelled &&
          styles.cancelledCard}`}
      >
        {widthWindows > 1024 ? (
          <div
            className={`${styles.cardHeader}
            ${shipping.blocked && styles.blockedShipping}`}
          >
            <div
              style={{
                backgroundColor: handleStatusColor(shipping.idShippingStatus)
              }}
              className={styles.dotStatus}
            />

            <div className={styles.content}>
              <div className={`${styles.groupInfo} ${styles.requests}`}>
                <div>
                  <PiNoteFill color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>
                    PEDIDO:
                  </strong>
                </div>
                {shipping?.orderNumber !== null &&
                  shipping?.orderNumber > 0 ? (
                  <span className={styles.shippingInfo}>
                    {shipping?.orderNumber}
                  </span>
                ) : "--"}
              </div>

              <div className={styles.usersGroupInfo}>
                <div className={`${styles.groupInfo} ${styles.clients}`}>
                  <div>
                    <FaUser color="#409E6A" size={18} />
                    <strong className={styles.titleDescription}>
                      CLIENTE:
                    </strong>
                  </div>
                  {clientName ? (
                    <span className={styles.shippingInfo} title={clientName} >{clientName}</span>
                  ) : "--"}
                </div>
              </div>

              <div className={`${styles.groupInfo} ${styles.identification}`}>
                <TbSearch color="#409E6A" size={22} />
                <strong className={styles.titleDescription}>IDENTIFICAÇÃO:</strong>
                {shipping?.sro !== null && !!shipping?.sro ? (
                  <a
                    href={`/detalhes-objeto/${shipping.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className={styles.shippingInfo} title={shipping.sro}>
                      <b>{shipping?.sro}</b>
                    </span>
                  </a>
                ) : "--"}
              </div>

              <div className={`${styles.groupInfo} ${styles.value}`}>
                <div>
                  <RiMoneyDollarCircleFill color="#409E6A" size={22} />
                  <strong className={styles.titleDescription}>VALOR:</strong>
                </div>
                <span className={styles.shippingInfo}>
                  {shipping?.price ? new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                  }).format(shipping?.price) : "--"}
                </span>
              </div>

              <strong className={styles.shippingTypeInfo}>
                {`${shipping?.correios?.nome?.replace("Entrega", "")}
                  ${shipping?.isLogisticsReverse ? " (Reversa)" : ""}
                  ${isCancelled ? " (Cancelado)" : ""}
                  `}
              </strong>
            </div>
            <div className={styles.actionButtonsContainer}>
              {expand &&
                (isExpand ? (
                  <div onClick={onExpand}>
                    <FiChevronUp />
                  </div>
                ) : (
                  <div onClick={onExpand}>
                    <FiChevronDown />
                  </div>
                ))}
            </div>
          </div>
        ) : (
          <div
            className={`${styles.cardHeaderMobile}
            ${shipping.blocked && styles.blockedShipping} ${isCancelled &&
              styles.cancelledCard}`}
          >
            <div className={styles.content}>
              {shipping?.orderNumber !== null && shipping?.orderNumber > 0 && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>PEDIDO:</strong>
                  <span className={styles.shippingInfo}>
                    {shipping?.orderNumber}
                  </span>
                </div>
              )}
              {shipping?.sro !== null && !!shipping?.sro && (
                <div className={styles.groupInfo}>
                  <strong className={styles.titleDescription}>IDENTIFICAÇÃO:</strong>
                  <span className={styles.shippingInfo}>{shipping?.sro}</span>
                </div>
              )}
              {shipping?.invoiceNumber !== null &&
                Number(shipping?.invoiceNumber) >= 1 &&
                !!shipping?.invoiceNumber && (
                  <div className={styles.groupInfo}>
                    <strong className={styles.titleDescription}>
                      NOTA FISCAL:
                    </strong>
                    <span className={styles.shippingInfo}>
                      {shipping?.invoiceNumber}
                    </span>
                  </div>
                )}
              <div className={styles.groupInfo}>
                <div className={styles.shippingTypeAndValue}>
                  <strong className={styles.titleDescription}>VALOR:</strong>
                  <span className={styles.shippingInfo}>
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    }).format(shipping?.price)}
                  </span>

                  <strong className={styles.shippingType}>
                    {`${shipping?.correios?.nome?.replace("Entrega", "")}${isCancelled ? " (Cancelado)" : ""
                      }`}
                  </strong>
                </div>
              </div>

            </div>
            <div className={styles.actionButtonsContainer}>
              <div style={{ display: "flex", gap: "8px" }}>
                {expand &&
                  (isExpand ? (
                    <div onClick={onExpand}>
                      <FiChevronUp className={styles.iconOpenClose} />
                    </div>
                  ) : (
                    <div onClick={onExpand}>
                      <FiChevronDown className={styles.iconOpenClose} />
                    </div>
                  ))}
                {(shipping?.numeroPLP <= 1 ||
                  shipping?.numeroPLP === "null") && (
                    <StyledTooltip text="Editar" position="top" arrow>
                      <FiEdit3
                        className={styles.iconEdit}
                        onClick={() => {
                          if (!isCancelled) {
                            history.push(
                              `/nova-coleta/send-form?shipping=${shipping?.id}`
                            );
                          }
                        }}
                      />
                    </StyledTooltip>
                  )}
              </div>
            </div>
          </div>
        )}

        <div className={!isExpand ? styles.cardBodyHidden : styles.cardBody}>
          <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>REMETENTE</h3>
            <div className={styles.collectInfo}>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Nome:</span>
                {shipping?.origin?.name}
              </p>
              <p>
                <span className={styles.highlighted}>CEP:</span>
                {formatCep(shipping?.origin?.zip)}
              </p>

              <p>
                <span className={styles.highlighted}>Endereço:</span>
                {addressInfoHandled({
                  street: shipping?.origin?.street,
                  number: shipping?.origin?.number,
                  complement: shipping?.origin?.complement,
                  district: shipping?.origin?.district
                })}
                - {`${shipping?.origin?.city}/${shipping?.origin?.state}`}
              </p>
            </div>
          </div>

          <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>DESTINATÁRIO</h3>
            <div className={styles.collectInfo}>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Nome:</span>
                {shipping?.destination?.name}
              </p>
              <p>
                <span className={styles.highlighted}>CEP:</span>
                {formatCep(shipping?.destination?.zip)}
              </p>

              <p>
                <span className={styles.highlighted}>Endereço:</span>
                {addressInfoHandled({
                  street: shipping?.destination?.street,
                  number: shipping?.destination?.number,
                  complement: shipping?.destination?.complement,
                  district: shipping?.destination?.district
                })}
                -{" "}
                {`${shipping?.destination?.city}/${shipping?.destination?.state}`}
              </p>
            </div>
          </div>

          <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>PACOTE</h3>
            <div className={styles.collectInfo}>
              <p>
                {shipping?.identificationPackage && (
                  <>{shipping?.identificationPackage} </>
                )}
                <span className={styles.highlighted}>Peso total:</span>
                {`${String(shipping?.weight)?.replace(".", ",")}kg`}
              </p>

              <p>
                <span className={styles.highlighted}>Envio com seguro:</span>
                {shipping?.insurance ? "Sim" : "Não"}
              </p>
              <p className={styles.highlighted}>
                <span className={styles.highlighted}>Previsão de entrega:</span>
                {shipping?.previewDate
                  ? momentBDays(shipping?.previewDate).format("DD/MM/YYYY")
                  : momentBDays(addBusinessDaysIgnoreHolidays(
                    shipping?.correios?.desconto > 0
                      ? Number(shipping?.correios?.prazoEntrega) + 2
                      : Number(shipping?.correios?.prazoEntrega),
                    shipping.destination.state
                  ))
                    .format("DD/MM/YYYY")}
              </p>

              <p>
                <span className={styles.highlighted}>Postagem:</span>
                {shipping?.rateType === RateTypeShippingEnum.RETAIL
                  ? "Correios"
                  : "Coleta"}
                {shipping?.identificationPackage && (
                  <>
                    {shipping?.identificationPackage} <br />
                  </>
                )}
              </p>
              <p>
                <span className={styles.highlighted}>Peso total:</span>
                {`${String(shipping?.weight)?.replace(".", ",")}kg`}
              </p>
            </div>
          </div>
          {/* <div
            className={
              !isExpand ? styles.cardContentHidden : styles.cardContent
            }
          >
            <h3>INFORMAÇÕES ADICIONAIS</h3>
            <div className={styles.collectInfo}>
              <span className={styles.highlighted}>Nota fiscal:</span>
              <span className={styles.handleInvoice}>Gerar nota fiscal</span>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

function cardShippingAreEqual(prevShipping, nextShipping) {
  const shippingHasSameCheckEqual =
    prevShipping.isSelected === nextShipping.isSelected;

  const widthWindowIsEqual =
    prevShipping.widthWindows === nextShipping.widthWindows;

  return shippingHasSameCheckEqual && widthWindowIsEqual;
}
export const CartSimpleCardShippingComponent = React.memo(
  CartSimpleCardShipping,
  cardShippingAreEqual
);
